import { Link } from 'react-router-dom';

/**
 * 404 page within the authenticated area
 */
export function NotFound() {
  return (
    <div className="page not-found">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
      <Link to="/" className="back-link">
        ← Go to Dashboard
      </Link>
    </div>
  );
}
